/**
 * Tehtävämuistutus (docs/PROJEKTINHALLINTA.md, luku 24).
 *
 * Muistutus on **hetki, ei jakso**: yksi tehtävä, yksi ajankohta, yksi
 * viesti per vastaanottaja. Siksi se ei käytä `reminder_send`in
 * jaksoavainta (`lib/reminders.ts`) vaan oman rivinsä lähetysleimaa.
 *
 * Tässä tiedostossa on se osa, jonka selain ja palvelin jakavat:
 * esivalintojen päivämäärät, rajat ja kohdejoukon nimet. Kaikki on puhdasta
 * — vastaanottajien valinta ja viestin muotoilu ovat palvelimen puolella
 * (`api/src/lib/taskReminders.ts`).
 */
import { addDays, isoWeekday } from './time.js';
/**
 * Kenelle muistutus lähtee. Vastaa kannan `KanbanReminderAudience`-enumia.
 *
 * `ASSIGNEE` ratkaistaan **lähetyshetkellä**, ei asetettaessa: muistutus
 * koskee tehtävän nykyistä tekijää, ja jos tehtävä on vaihtanut omistajaa,
 * viesti kuuluu uudelle. Asettaja on aina konkreettinen henkilö.
 */
export const KANBAN_REMINDER_AUDIENCES = ['SETTER', 'ASSIGNEE', 'BOTH'];
/** Saate: mistä muistutetaan. Menee viestiin sellaisenaan. */
export const KANBAN_REMINDER_NOTE_MAX = 500;
/**
 * Odottavia muistutuksia per tehtävä ja asettaja. Raja ei suojaa kantaa
 * vaan postilaatikkoa: viisi muistutusta samasta tehtävästä on jo merkki
 * siitä, ettei muistutus ollut se, mitä tarvittiin.
 */
export const KANBAN_REMINDER_MAX_PENDING = 5;
/** Kuinka kauas tulevaisuuteen muistutuksen voi asettaa. */
export const KANBAN_REMINDER_MAX_DAYS = 730;
/** Lähetetyt muistutukset näkyvät tehtävällä näin monta päivää. */
export const KANBAN_REMINDER_HISTORY_DAYS = 30;
/**
 * Esivalintojen kellonaika. Aamu eikä keskiyö: muistutus luetaan silloin,
 * kun työ alkaa, eikä se saa hukkua yön viestien joukkoon.
 */
export const KANBAN_REMINDER_DEFAULT_TIME = '09:00';
/**
 * Esivalinnat. Nimet ovat käyttöliittymän avaimia; päivä lasketaan
 * `taskReminderPresetDate`illa, jotta selain ja palvelin saavat saman
 * päivän samasta valinnasta.
 */
export const KANBAN_REMINDER_PRESETS = [
    'TOMORROW',
    'NEXT_MONDAY',
    'WEEKS_1',
    'WEEKS_2',
    'WEEKS_4',
];
/**
 * Esivalinnan päivä tästä päivästä laskettuna.
 *
 * `NEXT_MONDAY` on **seuraava** maanantai myös maanantaina: "ensi
 * maanantaina" tarkoittaa viikon päästä eikä tätä hetkeä, ja tänään klo 9
 * asetettu muistutus olisi jo mennyt.
 */
export function taskReminderPresetDate(preset, today) {
    switch (preset) {
        case 'TOMORROW':
            return addDays(today, 1);
        case 'NEXT_MONDAY':
            return addDays(today, 8 - isoWeekday(today));
        case 'WEEKS_1':
            return addDays(today, 7);
        case 'WEEKS_2':
            return addDays(today, 14);
        case 'WEEKS_4':
            return addDays(today, 28);
    }
}
//# sourceMappingURL=taskReminders.js.map